export default "__VITE_ASSET__CbgWMviA__"